import {ContractStatus} from '../../shared/DTO/contractStatus';
import {MeasurementUnit} from '../../shared/DTO/measurementUnit';
import {CpaModel} from './cpa.model';
import {ExtensionModel} from './extension.model';
import {BaseModel} from '../../base/models/base-model.model';
import {ServiceState} from '../../shared/DTO/serviceState';

export class ServiceModel extends BaseModel {
  private _code?: string;
  private _compositionProduct?: string;
  private _consumption?: string;
  private _contractStatus?: ContractStatus;
  private _cpa?: Array<CpaModel>;
  private _description?: string;
  private _expectedContract?: boolean;
  private _extensions?: Array<ExtensionModel>;
  private _extensionsQuantity?: number;
  private _includedQuantity?: number;
  private _keepOnTrasformation?: boolean;
  private _maxQuantity?: number;
  private _measurementUnit?: MeasurementUnit;
  private _minQuantity?: number;
  private _name?: string;
  private _subscription?: boolean;
  private _typology?: string;
  private _value?: string;
  private _editable?: boolean;
  private _state?: ServiceState;

  constructor(code?: string, compositionProduct?: string, consumption?: string, contractStatus?: ContractStatus, cpa?: Array<CpaModel>, description?: string, expectedContract?: boolean, extensions?: Array<ExtensionModel>, extensionsQuantity?: number, includedQuantity?: number, keepOnTrasformation?: boolean, maxQuantity?: number, measurementUnit?: MeasurementUnit, minQuantity?: number, name?: string, subscription?: boolean, typology?: string, value?: string, editable?: boolean, state?: ServiceState) {
    super();
    this._code = code;
    this._compositionProduct = compositionProduct;
    this._consumption = consumption;
    this._contractStatus = contractStatus;
    this._cpa = cpa;
    this._description = description;
    this._expectedContract = expectedContract;
    this._extensions = extensions;
    this._extensionsQuantity = extensionsQuantity;
    this._includedQuantity = includedQuantity;
    this._keepOnTrasformation = keepOnTrasformation;
    this._maxQuantity = maxQuantity;
    this._measurementUnit = measurementUnit;
    this._minQuantity = minQuantity;
    this._name = name;
    this._subscription = subscription;
    this._typology = typology;
    this._value = value;
    this._editable = editable;
    this._state = state;
  }

  get state(): ServiceState {
    return this._state;
  }

  set state(value: ServiceState) {
    this._state = value;
  }

  get editable(): boolean {
    return this._editable;
  }

  set editable(value: boolean) {
    this._editable = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get compositionProduct(): string {
    return this._compositionProduct;
  }

  set compositionProduct(value: string) {
    this._compositionProduct = value;
  }

  get consumption(): string {
    return this._consumption;
  }

  set consumption(value: string) {
    this._consumption = value;
  }

  get contractStatus(): ContractStatus {
    return this._contractStatus;
  }

  set contractStatus(value: ContractStatus) {
    this._contractStatus = value;
  }

  get cpa(): Array<CpaModel> {
    return this._cpa;
  }

  set cpa(value: Array<CpaModel>) {
    this._cpa = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get expectedContract(): boolean {
    return this._expectedContract;
  }

  set expectedContract(value: boolean) {
    this._expectedContract = value;
  }

  get extensions(): Array<ExtensionModel> {
    return this._extensions;
  }

  set extensions(value: Array<ExtensionModel>) {
    this._extensions = value;
  }

  get extensionsQuantity(): number {
    return this._extensionsQuantity;
  }

  set extensionsQuantity(value: number) {
    this._extensionsQuantity = value;
  }

  get includedQuantity(): number {
    return this._includedQuantity;
  }

  set includedQuantity(value: number) {
    this._includedQuantity = value;
  }

  get keepOnTrasformation(): boolean {
    return this._keepOnTrasformation;
  }

  set keepOnTrasformation(value: boolean) {
    this._keepOnTrasformation = value;
  }

  get maxQuantity(): number {
    return this._maxQuantity;
  }

  set maxQuantity(value: number) {
    this._maxQuantity = value;
  }

  get measurementUnit(): MeasurementUnit {
    return this._measurementUnit;
  }

  set measurementUnit(value: MeasurementUnit) {
    this._measurementUnit = value;
  }

  get minQuantity(): number {
    return this._minQuantity;
  }

  set minQuantity(value: number) {
    this._minQuantity = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get subscription(): boolean {
    return this._subscription;
  }

  set subscription(value: boolean) {
    this._subscription = value;
  }

  get typology(): string {
    return this._typology;
  }

  set typology(value: string) {
    this._typology = value;
  }

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
  }
}
